@if (noQRCode) {
  <div class="row" [formGroup]="attachForm">
    <div class="col-md-12 p-fluid">
      <h4 class="custom-h4-title">{{ 'iScan.globalInfos.searchToAttach' | translate }}</h4>
      @if (mailNotFoundWithQRCode) {
        <div class="alert alert-warning">
          {{ 'iScan.information.mailFileNotFoundWithId' | translate }}
          @if (idFound) {
            <div>{{ 'foundId' | translate }}: {{ idFound }}</div>
          }
        </div>
      }
      @if (selectedMailRight && !selectedMailRight.files.add) {
        <div class="alert alert-warning">
          {{ 'iScan.information.noRightsToAddAFileOnThisMail' | translate }}
          @if (idFound) {
            <div>{{ 'iScan.information.idFoundByQRCode' | translate }}: {{ idFound }}</div>
          }
        </div>
      }
      <p-autoComplete
        minLength="1"
        formControlName="linkMailId"
        appendTo="body"
        id="autocompleteAttachToCourrier"
        [suggestions]="results"
        (completeMethod)="searchMailAutocomplete($event)"
        [placeholder]="'courrierFiche.searchMailById' | translate"
        (onSelect)="onSelectMail()">
      </p-autoComplete>
    </div>
    <div class="col-md-12 mt-4 d-flex justify-content-end">
      <i-button
        [text]="'iScan.information.addToMail' | translate"
        styleClass="green"
        id="buttonAttachToCourrier"
        (click)="submitAttachForm()"
        [disabled]="!attachForm.valid || !selectedMailRight || (selectedMailRight && selectedMailRight.files && !selectedMailRight.files?.add)">
      </i-button>
    </div>
  </div>
}
@if (!noQRCode) {
  <div class="row" [formGroup]="attachForm">
    <div class="col-md-12 p-fluid">
      <h4 class="custom-h4-title">{{ 'iScan.information.mailFoundByQRCode' | translate }}</h4>
      <div class="alert alert-success">
        {{ 'iScan.information.mailWasFoundWithIdYouCanAttachAScanToIt' | translate: { foundMailId: foundMailByQRCodeId?.id } }}
        <p></p>
        @if (foundMailByQRCodeId?.canViewMail) {
          <p>
            <b>{{ 'iScan.information.mailFileObject' | translate }}</b>
            {{ foundMailByQRCodeId?.objet ? foundMailByQRCodeId?.objet : ('courrier.mailWithoutObject' | translate) }}
          </p>
        } @else {
          {{ 'iScan.information.mailFileObjectCannotView' | translate }}
        }
      </div>
      <div class="col-md-12 mt-4 d-flex justify-content-between">
        <i-button text="Choisir manuellement" styleClass="red" id="buttonAttachToCourrierManual" (click)="changeToAttachManual()"> </i-button>
        <i-button text="Ajouter au courrier" styleClass="blue" id="buttonAttachToCourrier" (click)="submitAttachForm()"> </i-button>
      </div>
    </div>
    <p-confirmDialog
      baseZIndex="560"
      #cd
      [header]="'global.confirmHeader' | translate"
      styleClass="super-compos-modal-content confirmModal"
      icon="bi bi-exclamation-triangle">
      <p-footer>
        <button type="button" pButton icon="pi pi-times" label="Non" (click)="cd.reject()"></button>
        <button class="pButtonRed" type="button" pButton icon="pi pi-check" label="Oui" (click)="cd.accept()"></button>
      </p-footer>
    </p-confirmDialog>
  </div>
}
